module.exports = __webpack_public_path__ + "static/img/g_stomach.dfe8846e.webp";